import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import App from './app/App';
import './index.scss';
import './i18';
//import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
//import { ApplicationInsights } from '@microsoft/applicationinsights-web';

//const reactPlugin = new ReactPlugin();
// export const appInsights = new ApplicationInsights({
//     config: {
//         connectionString: `InstrumentationKey=b2af36f7-2d2a-472a-a50b-0cb5acf00991;IngestionEndpoint=https://southeastasia-1.in.applicationinsights.azure.com/;LiveEndpoint=https://southeastasia.livediagnostics.monitor.azure.com/;ApplicationId=5dcb913e-22c9-4ab0-92d9-0cddd7b67fdf`,
//         enableAutoRouteTracking: true,
//         extensions: [reactPlugin],
//     },
// });

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
//appInsights.loadAppInsights();
reportWebVitals();
